import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiDialog-paper': {
      borderRadius: 32,
    },
  },
  content: {
    width: '100%',
    minWidth: 360,
    height: '100%',
  },
  infoContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    marginBottom: 8,
  },
  info: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    borderRadius: 16,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: 'rgba(112, 48, 160, 0.2)',
  },
  infoTextContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  infoTitle: {
    fontWeight: 700,
    textAlign: 'center',
  },
  infoText: {
    fontWeight: 500,
    textAlign: 'center',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 8,
  },
  inputLabel: {
    fontWeight: 700,
    textAlign: 'left',
    alignSelf: 'left',
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
  },
  formLabel: {
    fontSize: 14,
    fontWeight: 700,
  },
  formControl: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 120,
    width: '100%',
    backgroundColor: 'rgba(195, 155, 225, 0.2)',
    borderRadius: 16,
    borderStyle: 'solid',
    borderWidth: 0,
    marginBottom: 16,
    '&:first-child': {
      marginTop: 16,
    },
  },
  select: {
    borderRadius: 16,
    width: '100%',
    minWidth: 360,
    // marginBottom: 16,
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: 0,
    },
  },
  selectIcon: {
    marginLeft: 8,
    color: theme.palette.primary.main,
  },
  helperText: {
    color: '#F30',
    position: 'absolute',
    bottom: -16,
    left: 16,
  },
  delayContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 8,
  },
  inputDelayContainer: {
    marginLeft: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  inputDelayContent: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  inputDelay: {
    backgroundColor: 'rgba(112, 48, 160, 0.2)',
    borderRadius: 16,
    height: 40,
    width: 60,
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: 0,
      borderRadius: 16,
      height: 46,
    },
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    marginBottom: 8,
    paddingLeft: 16,
    paddingRight: 16,
  },
  button: {
    width: '45%',
    borderRadius: 16,
  },
  sortButton: {
    marginTop: 16,
    backgroundColor: theme.palette.common.white,
    border: '1px solid #EBEDEF',
    boxSizing: 'border-box',

    '&:last-child': {
      marginBottom: 16,
    },
  },
  sortButtonActive: {
    border: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.common.white,
  },
  search: {
    width: '100%',
    height: 56,
    borderRadius: 16,
    marginTop: 16,
    marginBottom: 16,
    backgroundColor: theme.palette.common.white,
    '&:hover': {
      borderColor: '#7030A0',
    },
    '& .Mui-disabled': {
      backgroundColor: theme.palette.background.default,
      borderRadius: 16,
    },
    '& input': {
      textAlign: 'flex-start',
      fontSize: 14,
      height: 56,
    },
    '& input::placeholder': {
      color: 'rgba(0,0,0,1)',
      fontSize: 12,
      textAlign: 'left',
    },
    '& .MuiOutlinedInput-input': {
      borderWidth: 0,
    },
    '& .MuiOutlinedInput-input:focus': {
      // backgroundColor: '#FF0',
    },
    '& .Mui-focused': {
      border: 'none',
    },
  },
  selectEquipment: {
    width: '100%',
    height: 160,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'left',
    backgroundColor: '#FFF',
    overflowY: 'scroll',
    overflowX: 'hidden',
    borderRadius: 16,
    border: '1px solid hsla(210, 11%, 93%, 1)',

    '&::-webkit-scrollbar': {
      height: 6,
      width: 4,
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 4px #9DA5B1',
      borderRadius: 2,
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#9DA5B1',
      borderRadius: 2,
    },
  },
  checkbox: {
    width: '100%',
    marginLeft: 16,
    fontSize: 14,
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
  },
}));
